import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ReliabotixLogo from './ReliabotixLogo';

const { FiGithub, FiLinkedin, FiMail, FiHeart, FiShield, FiFileText, FiExternalLink } = FiIcons;

const Footer = () => {
  return (
    <footer className="relative glass-strong border-t border-white/10">
      {/* Floating orbs */}
      <div className="floating-orb floating-orb-1"></div>
      <div className="floating-orb floating-orb-2"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <ReliabotixLogo size={48} variant="full" animate={true} />
              <span className="text-xl font-bold text-white">
                Reliabotix
              </span>
            </div>
            <p className="text-gray-300 mb-8 max-w-md leading-relaxed">
              Platform-agnostic AI development solutions. We transform business operations with intelligent automation,
              rapid MVP development, and cutting-edge VibeCoding methodology.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://github.com/guychenya"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-xl glass-card text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <SafeIcon icon={FiGithub} className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com/in/guychenya"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-xl glass-card text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
              </a>
              <a
                href="mailto:info@reliabotix.com"
                className="flex items-center justify-center w-10 h-10 rounded-xl glass-card text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"
              >
                <SafeIcon icon={FiMail} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-6 text-gray-300">Services</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">AI App Development</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Intelligent Automation</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Analytics & Insights</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Cloud Integration</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Enterprise Solutions</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider mb-6 text-gray-300">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/solutions" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Solutions Showcase</Link></li>
              <li><Link to="/demos" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Live Demos</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Get Started</Link></li>
              <li>
                <a
                  href="https://github.com/guychenya"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary-400 transition-colors duration-200 inline-flex items-center"
                >
                  Open Source
                  <SafeIcon icon={FiExternalLink} className="w-3 h-3 ml-1" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links & Copyright */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-4 md:mb-0">
              <p className="text-gray-400 text-sm flex items-center">
                © 2025 Reliabotix AI Solutions. Crafted with
                <SafeIcon icon={FiHeart} className="w-4 h-4 mx-1 text-red-500" />
                for intelligent automation.
              </p>
            </div>
            <div className="flex items-center gap-6">
              <Link
                to="/privacy"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-200 text-sm inline-flex items-center"
              >
                <SafeIcon icon={FiShield} className="w-3 h-3 mr-1" />
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-200 text-sm inline-flex items-center"
              >
                <SafeIcon icon={FiFileText} className="w-3 h-3 mr-1" />
                Terms of Use
              </Link>
              <Link
                to="/legal"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-200 text-sm inline-flex items-center"
              >
                <SafeIcon icon={FiShield} className="w-3 h-3 mr-1" />
                Legal
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;